function arredondaDecimal(valor, casasDecimais) {
    return Number(Math.round(valor + 'e' + casasDecimais) + 'e-' + casasDecimais);
}

export default arredondaDecimal;